import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { leaveIsHourly, leaveTotalDaysOrHours } from 'modules/timeoff/lib/leaveEmployees'
import type Leave from 'modules/timeoff/store/models/Leave'

interface Props {
  leave: Leave
  className?: string
}

const LeaveInfo = ({ leave, className }: Props) => {
  const backgroundColor = leave.typeColor

  const leaveStringDuration = (currentLeave: Leave) => {
    const total = leaveTotalDaysOrHours(currentLeave)

    if (!leaveIsHourly(currentLeave) && currentLeave.attributes.half_day && total === 0.5) {
      const firstHalf = currentLeave.isHalfDayBeginningOfDay()

      return firstHalf
        ? i18n.t('time_off.half_day_item.beggining_of_day')
        : i18n.t('time_off.half_day_item.end_of_day')
    }

    return leaveIsHourly(currentLeave)
      ? i18n.tp('time_off.hours_with_years', {
          count: total,
        })
      : i18n.tp('time_off.days_with_years', {
          count: total,
        })
  }

  const leaveName = leave
    ? leave.leaveType?.name || i18n.t('settings.leave_types.defaults.medical_leave')
    : ''

  const totalLeave = leave ? leaveStringDuration(leave) : 0

  return (
    <Box paddingTop="s6">
      <Box flexDirection="row" justifyContent="spaceBetween" textAlign="left">
        <Text.Normal color="grey000White">
          <span
            className={className}
            style={{
              backgroundColor,
            }}
          >
            {leaveName}
          </span>
        </Text.Normal>
        <Text.Normal color="grey000White">{totalLeave}</Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(LeaveInfo)
